function leishVic(){
    return{
        "games":[
            {
                "informs":[
                    {
                        "text":"Na área urbana, o cão (Canis <i>familiaris</i>) é a principal fonte de infecção, sendo que ocorrem mais casos da doença em cães do que no homem.",
                        "title":"Quem está envolvido no ciclo da doença?",
                        "image":"images/games/informs/leishVic/1.png"
                    },
                    {
                        "text":"Na área silvestre, os reservatórios são as raposas (Dusicyon <i>vetulus</i> e Cerdocyon <i>thous</i>) e os marsupiais (Didelphis <i>albiventris</i>).",
                        "title":"Quem está envolvido no ciclo da doença?",
                        "image":"images/games/informs/leishVic/1.png"
                    },
                    {
                        "text":"No Brasil, as raposas infectadas foram encontradas nas regiões Nordeste, Sudeste e Amazônica. A primeira vacina canina contra a doença foi desenvolvida pela pesquisadora brasileira Clarisa Beatriz Palatnik de Sousa.",
                        "title":"Quem está envolvido no ciclo da doença?",
                        "image":"images/games/informs/leishVic/1.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/leishVic/1.jpg"
        },
        {
                "informs":[
                    {
                        "text":"O agente causador da Leishmaniose Visceral nas Américas é a Leishmania <i>chagasi</i>. Em seu ciclo de vida, o parasita assume as diferentes formas: amastigota e promastigota. ",
                        "title":"Quem causa a doença?",
                        "image":"images/games/informs/leishVic/2.png"
                    },
                    {
                        "text":"Ao picar um animal ou uma pessoa infectada, o vetor contrai a forma amastigota. ",
                        "title":"Quem causa a doença?",
                        "image":"images/games/informs/leishVic/2.png"
                    },
                    {
                        "text":"No interior do vetor, o parasita se desenvolve, transforma-se em promastigota, e se reproduz. Ao picar indivíduos saudáveis, o mosquito inocula o parasita, este, desenvolve-se e assume a forma amastigota completando seu ciclo evolutivo.",
                        "title":"Quem causa a doença?",
                        "image":"images/games/informs/leishVic/2.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/leishVic/2.jpg"
            },
        {
                "informs":[
                    {
                        "text":"Os sintomas podem variar de paciente para paciente, mas a maioria dos casos inclui febre com duração inferior a 4 semanas, palidez da pele e mucosas e aumento do fígado e baço.",
                        "title":"Quais os sintomas da doença?",
                        "image":"images/games/informs/leishVic/3.png"
                    },
                    {
                        "text":" Caso não seja feito o diagnóstico e tratamento, a doença evolui progressivamente para o período final, com febre contínua e comprometimento mais intenso do estado geral: desnutrição, ascite (barriga d’água), hemorragias e icterícia.",
                        "title":"Quais os sintomas da doença?",
                        "image":"images/games/informs/leishVic/3.png"
                    },
                    {
                        "text":"Na maioria dos casos, o período de incubação é de 2 a 4 meses após a picada.",
                        "title":"Quais os sintomas da doença?",
                        "image":"images/games/informs/leishVic/3.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/leishVic/3.jpg"
            },
        {
                
                "informs":[
                    {
                        "text":"A transmissão da Leishmaniose Visceral ocorre quando o inseto Lutzomya <i>longipalpis</i> ou Lutzomya <i>cruzi</i> infectado pela Leishmania <i>chagasi</i> pica a pessoa.",
                        "title":"Como a doença é transmitida?",
                        "image":"images/games/informs/leishVic/4.png"
                    },
                    {
                        "text":"Apenas o mosquito fêmea adquire o parasita, ao sugar o sangue de mamíferos infectados, engere células parasitadas.",
                        "title":"Como a doença é transmitida?",
                        "image":"images/games/informs/leishVic/4.png"
                    },
                        {
                        "text":"No trato digestivo do vetor, o parasita se desenvolve e migra para o esôfago e faringe, onde se diferencia em formas infectantes, transmitidas ao homem no momento da picada. Tal ciclo se completa em torno de 72 horas.",
                        "title":"Como a doença é transmitida?",
                        "image":"images/games/informs/leishVic/4.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/leishVic/4.jpg"
            },
        {
                "informs":[
                    {
                        "text":"São medidas preventivas contra a Leishmaniose Visceral: evitar que o mosquito se prolifere, eliminando água parada e limpa;",
                        "title":"Como fazer a prevenção?",
                        "image":"images/games/informs/leishVic/5.png"
                    },
                    {
                        "text":"usar roupas de manga longa e calças compridas em atividades nos horários crepusculares cuja atividade do vetor é intensa;",
                        "title":"Como fazer a prevenção?",
                        "image":"images/games/informs/leishVic/5.png"
                    },
                        {
                        "text":"usar tela em portas e janelas, mosquiteiros impregnados com inseticida e repelente na pele exposta seguindo a orientação do fabricante sobre o prazo para reaplicação do produto e controlar a população canina para prevenir a doença em cães.",
                        "title":"Como fazer a prevenção?",
                        "image":"images/games/informs/leishVic/5.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/leishVic/5.jpg"
            }
        ]
    };
}

export{leishVic};